export const normalizeCpfCnpj = (value) => String(value || '').replace(/\D/g, '').slice(0, 14);

const repeatedDigits = (value) => /^(\d)\1+$/.test(value);

const calculateDigit = (value, weights) => {
  const total = weights.reduce((sum, weight, index) => sum + Number(value[index]) * weight, 0);
  const remainder = total % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

export const isValidCpfCnpj = (value) => {
  const digits = normalizeCpfCnpj(value);
  if (!digits) return true;
  if (repeatedDigits(digits)) return false;

  if (digits.length === 11) {
    const first = calculateDigit(digits, [10, 9, 8, 7, 6, 5, 4, 3, 2]);
    const second = calculateDigit(digits, [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);
    return first === Number(digits[9]) && second === Number(digits[10]);
  }

  if (digits.length === 14) {
    const first = calculateDigit(digits, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    const second = calculateDigit(digits, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    return first === Number(digits[12]) && second === Number(digits[13]);
  }

  return false;
};

export const formatCpfCnpj = (value) => {
  const digits = normalizeCpfCnpj(value);
  if (digits.length <= 11) {
    return digits
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }
  return digits
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
};
